import { NEW_RELIC_ACCOUNT, NEW_RELIC_KEY } from 'common/constants'
import { sendDataNative } from 'components/hooks/useFetchNative'
import { useTrack as trackData } from 'inter-frontend-hooks'
import { ITrackEvent } from 'interfaces/trackEvent.interface'
import url from 'shared/functions/url'
import { convertBooleanObjectToString } from 'utils/format/formatObject'
import { verifyVersions } from 'utils/version'

const appVersion = url.queryParam().version ?? localStorage.getItem('version')

const sendToNewRelic = (
  eventType: string,
  eventSubType: string,
  moreInfo?: Record<string, unknown>,
) =>
  appVersion && verifyVersions(appVersion)
    ? sendDataNative<ITrackEvent>({
        method: 'TRACKEVENT',
        body: {
          eventType: 'AberturaContaPFReact',
          name: 'Abertura de Conta Digital PF',
          parameters: {
            transactionType: eventType.toString(),
            transactionSubType: eventSubType.toString(),
            originEvent: 'Nativo',
            ...convertBooleanObjectToString(moreInfo),
          },
        },
      })
    : trackData({
        type: 'insightsCollector',
        dataReport: {
          ...convertBooleanObjectToString(moreInfo),
          transactionType: eventType.toString(),
          eventType: 'AberturaContaPFReact',
          name: 'Abertura de Conta Digital PF',
          appName: 'CDPF REACT',
          transactionSubType: eventSubType.toString(),
          originEvent: 'Webview',
        },
        account: NEW_RELIC_ACCOUNT,
        key: NEW_RELIC_KEY,
      })

export default sendToNewRelic
